import { useContextState } from "../../../../../../../../../../hooks/theme"



const useStyles = () => {
  const { colors } = useContextState()
  return {
    buttonWithoutBorder: {
      display: 'flex',
      gap: 2
    },
    body: {
      height: '100%',
      paddingLeft: 3,
      display: 'flex',
      flexDirection: 'column',
      gap: 3
    },
    child: {
      display: 'flex',
      flexDirection: 'column',
      gap: 3
    },
    userContainer: {
      padding: 2,
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      '& .MuiTypography-root': {
        color: colors.color13,
      },
      '& .bold': {
        fontWeight: 'bold'
      },
    },
    destinationContainer: {
      padding: 2,
      '& .MuiTypography-root': {
        color: colors.color13,
      },
      '& .bold': {
        fontWeight: 'bold'
      },
    },
    filters: {
      position: 'relative',
      padding: 3,
      border: `1px solid ${colors.color13}`,
      borderRadius: 1,
      '& .MuiFormControlLabel-label': {
        color: colors.color13,
      }
    },
    map: {
      height: '100%',
      width: '100%'
    },
    mapModal: {
      width: '60vw',
      padding: 2,
      height: '600px',
    },
    cleanFilters: {
      position: 'absolute',
      left: '120px',
      top: '-60px',
    },
    table: ({ row }: { row: boolean }) => ({
      '& .MuiPaper-root': {
        height: row ? '400px' : '40px',
        width: '100%'
      }
    })
  }
}

export { useStyles }
